<template>
  <v-dialog v-model="dialog" max-width="500px">
    <template v-slot:activator="{ on }">
      <v-btn depressed color="secondary" small v-on="on">{{$t("buildingComponentDetails")}}</v-btn>
    </template>
    <v-card>
      <v-tabs fixed-tabs>
        <v-tab left ripple>{{$t("edit")}} {{$t("buildingComponent")}}</v-tab>
        <v-tab-item>
          <v-divider></v-divider>
          <v-card class="mt-5 container" flat>
            <v-form ref="form" v-model="valid" lazy-validation>
                  <v-text-field
                    outlined
                    dense
                    :rules="nameRules()"
                    required
                    v-model="buildingComponent.name"
                    v-bind:label="$t('name')"
                  ></v-text-field>
                  <v-textarea
                    outlined
                    dense
                    required
                    v-model="buildingComponent.description"
                    v-bind:label="$t('description')"
                  ></v-textarea>
            </v-form>
          </v-card>
        </v-tab-item>
      </v-tabs>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="close">{{$t('close')}}</v-btn>
        <v-btn color="primary" text @click="save">{{$t('save')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    buildingComponent: Object
  },
  name: "test",
  data: () => ({
    valid: false,
    dialog: false,
    hasImage: false
  }),
  created() {},
  methods: {
    close() {
      this.dialog = false;
    },
    nameRules() {
      return [v => !!v || `${this.$t("name")} ${this.$t("required")}`];
    },
    descriptionRules() {
      return [v => !!v || `${this.$t("description")} ${this.$t("required")}`];
    },
    save() {
      if (this.$refs.form.validate()) {
        if (this.valid) {
          this.buildingComponent.modifiedBy = localStorage.getItem("user");
          this.$emit("edit", this.buildingComponent);
          this.close();
        }
      }
    }
  }
};
</script>


<style>
#fileInput {
  display: none;
}
.img-preview {
  height: 150px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/BuildingComponents/EditBuildingComponent.vue